import script from "./InputCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./InputCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./InputCheckbox.vue?vue&type=style&index=0&id=0e025705&lang=scss"

const __exports__ = script;

export default __exports__